<template>
  <div class="differentiating-benefits-content">
    <div
      class="differentiating-benefits-banner-image"
      :style="{ backgroundImage: `url(${differentiatingBenefitsBannerImageSrc})` }"
    ></div>
    <div class="differentiating-benefits-overlay-image">
      <h1 class="differentiating-benefits-banner-title">
        {{ differentiatingBenefitsBannerImageTitle }}
      </h1>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import DifferentiatingBenefitsPageMixin from '@/mixins/differentiating-benefits-page-mixin'
import { DifferentiatingBenefitsPageStore } from '@/store/brand-plataform-page/differentiating-benefits-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class DifferentiatingBenefitsBannerSection extends Mixins(
  DifferentiatingBenefitsPageMixin
) {
  differentiatingBenefitsPageStore: PageStoreContract = getModule(
    DifferentiatingBenefitsPageStore,
    this.$store
  )

  get differentiatingBenefitsBannerImageTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get differentiatingBenefitsBannerImageSrc(): string {
    return this.getElementMedia(0, 0)
  }

  async getDifferentiatingBenefitsPageStore(): Promise<void> {
    await this.differentiatingBenefitsPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.differentiatingBenefitsPageStore.isLoading) {
      await this.getDifferentiatingBenefitsPageStore()
    }
  }
}
</script>

<style lang="scss">
.differentiating-benefits-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: gray;
  max-height: 28rem;
  width: 100%;
}

.differentiating-benefits-banner-image {
  position: relative;
  width: 100%;
  height: 451px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.differentiating-benefits-overlay-image {
  position: absolute;
  bottom: 5.5rem;
  left: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 1;
  pointer-events: none;
  text-align: left;
}

.differentiating-benefits-banner-title {
  font-size: 8rem;
  width: 1rem;
  margin: 0;
  font-weight: 400;
  line-height: 7.25rem;
  letter-spacing: -0.01em;
  text-align: left;
}
</style>
